module.exports = __webpack_public_path__ + "img/role-back.91011a38.png";